module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-10"
  }, _vm._l((_vm.options), function(option) {
    return _c('div', {
      staticClass: "m-t-10",
      class: {
        'inlineCheckbox': !option.child
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": option.id
      },
      on: {
        "change": function($event) {
          _vm.selectThis(option)
        }
      }
    }, [_vm._v(_vm._s(option.name))]), _vm._v(" "), (option.child) ? [_c('checkbox-demo', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.childValue),
        expression: "childValue"
      }],
      attrs: {
        "index": _vm.index,
        "options": option.child
      },
      domProps: {
        "value": (_vm.childValue)
      },
      on: {
        "input": [function($event) {
          _vm.childValue = $event
        }, _vm.change],
        "isAll": _vm.isAll
      }
    })] : _vm._e()], true)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13dcdff7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/instance/checkboxDemo.vue
// module id = 1781
// module chunks = 2